import {Ambiente} from '../app/components/shared/enum/ambiente';


export const environment = {
  ambiente: Ambiente.HML,
  newRelicEnabled: false,
  urlWeb: 'https://hml-parceiros.gruposfa.com.br/',
  urlBase: 'https://hml-api-parceiros.gruposfa.com.br/api',
  urlSocket: 'http://hml-api-portal-sp.gruposfa.com.br/ws-server',
  urlRepositorioPortal: 'http://repositorio.gruposfa.com.br/api-portal/hml',
};
